module.exports = __webpack_public_path__ + "db2aa268f7b4929b3c1bfca40643e031.png";